import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soci-paganti',
  templateUrl: './soci-paganti.component.html',
  styleUrls: ['./soci-paganti.component.css']
})
export class SociPagantiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
